export default __webpack_public_path__ + "static/media/ai-icon-white.e16fd826.svg";